export default __webpack_public_path__ + "static/media/Heart_icon.b365f6a9.svg";